<div class="help-list__sections">
  <div *ngFor="let section of helpSections$ | async; trackBy: trackByUrl" [routerLink]="['/help', section.url]"
    class="help-list__section" analytics [click]='true' [category]="'Menu - How to Play'" [label]="section.title">
    <div class="help-list__section-name">
      {{ section.title }}
    </div>
    <i class="help-list__caret fa fa-angle-right"></i>
  </div>
</div>
<app-loading-bar [show]="loading"></app-loading-bar>